import { SxProps } from '@mui/material'
import { COLORS } from '@/styles'

export interface EventDetailsStyles {
  limitedSeats: SxProps
  title: SxProps
  details: SxProps
  infoText: SxProps
  chipsWrapper: SxProps
  leadText: SxProps
  eventTime: SxProps
  mapView: SxProps
}

export const eventDetailsStyles: EventDetailsStyles = {
  limitedSeats: {
    typography: 'textSmSemibold',
    color: COLORS.BLAZING_SUNSET,
    p: 1,
    borderRadius: 2,
    backgroundColor: COLORS.SOFT_BLUSH,
  },
  title: { typography: 'textMdSemibold', color: 'text.primary' },
  details: { textTransform: 'capitalize' },
  infoText: { typography: 'textSm', color: 'text.primary', mt: 0.25 },
  leadText: { typography: 'textSmSemibold', color: 'text.primary' },
  chipsWrapper: { display: 'flex', gap: 0.75, mt: 0.25, flexWrap: 'wrap' },
  eventTime: { mt: 0.5 },
  mapView: {
    height: 164,
    borderRadius: 6,
    backgroundColor: 'utils.gray200',
  },
}
